import { dataaccess } from "../dataaccess/dataContext";

let peopleSearchUrl = "/People/GetPeopleData/";

function init() {

}

function getPeople(currentPage, filters) {
    return dataaccess.post({ url: peopleSearchUrl + currentPage, method: "POST", data: filters });
}

function setSearchUrl(url) {
    peopleSearchUrl = url;
}

export const peopleSearch = {
    init: init,
    getPeople: getPeople,
    setSearchUrl: setSearchUrl
};